
import { useHistory, useLocation } from 'react-router-dom';

import HomeIcon from '@mui/icons-material/Home';
import {
  Box,
  Button,
  Container,
  Typography,
} from '@mui/material';

import styles from './NotFound404.module.css';

const NotFound404 = () => {
  const history = useHistory();
  const location = useLocation();

  return (
    <div className={styles.container}>
      <Container maxWidth="sm">
        <div className={styles.content}>
          <Box mb={4}>
            <Typography
              className={styles.title}
              color="text.primary"
              component="h1"
              variant="h1"
            >
              404
            </Typography>
            <Box
              className={styles.underline}
              sx={{ backgroundColor: 'primary.main' }}
            />
          </Box>

          <Typography
            component="h2"
            gutterBottom
            sx={{ fontWeight: 'bold' }}
            variant="h4"
          >
            Oops! Page not found
          </Typography>

          <Button
            className={styles.homeButton}
            onClick={() => history.push('/')}
            size="large"
            startIcon={<HomeIcon />}
            variant="contained"
          >
            Back to Home
          </Button>

          <div className={styles.dotsContainer}>
            <Box
              className={styles.dot}
              sx={{ backgroundColor: 'primary.main' }}
            />
            <Box
              className={styles.dot}
              sx={{ backgroundColor: 'primary.main' }}
            />
            <Box
              className={styles.dot}
              sx={{ backgroundColor: 'primary.main' }}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NotFound404;